<template>
	<accordion
			v-if="items.length>0"
			:initialOpenItem="open ? 1 : null"
			:dropdown="false"
			:icon="'plus-minus'">
		<accordion-item>
			<span slot="title" class="help">In order to make sentences viable for any student, use magic templates like shown below <span class="has-text-info">(click on any of items in order to add it to sentence above)</span>:</span>
			<div slot="content" class="columns is-multiline">
				<div class="column is-4">
					<span class="help" v-for="(item, index) in items" v-if="index < items.length/3"><a @click="addToSentence(item.alias)"  href="javascript:{}" v-html="item.alias"></a> - <span v-html="item.description"> </span> <span v-if="item.schools && item.schools.length > 0"> (Recommended for: <span v-for="(school, index) in item.schools">{{index ==0 ? school.name : ', '+school.name}}</span>  )</span></span>
				</div>
				<div class="column is-4">
					<span class="help" v-for="(item, index) in items" v-if="index >= items.length/3 && index < 2*items.length/3"><a @click="addToSentence(item.alias)"  href="javascript:{}" v-html="item.alias"></a> - <span v-html="item.description"> </span> <span v-if="item.schools && item.schools.length > 0"> (Recommended for: <span v-for="(school, index) in item.schools">{{index ==0 ? school.name : ', '+school.name}}</span>  )</span></span>
				</div>
				<div class="column is-4">
					<span class="help" v-for="(item, index) in items" v-if="index >= 2*items.length/3"><a @click="addToSentence(item.alias)"  href="javascript:{}" v-html="item.alias"></a> - <span v-html="item.description"> </span> <span v-if="item.schools && item.schools.length > 0"> (Recommended for: <span v-for="(school, index) in item.schools">{{index ==0 ? school.name : ', '+school.name}}</span>  )</span></span>
				</div>
			</div>
		</accordion-item>
	</accordion>
</template>

<script>
export default {
    name: 'magic-words',
    props: {
        items: { required: true , type:Array},
        open: { required: false , type:Boolean, default:true},
    },
    data () {
		return {
		};
    },
    methods: {
        addToSentence(alias){
			this.$emit('clickOnItem', alias);
		}
    },    
    mounted () {

	},
	created () {
		//console.log(this.items);
	},
    watch: {
        items(value){
			//console.log(value);
        },

    }

}
</script>

<style  lang="scss" scoped>



</style>



// WEBPACK FOOTER //
// src/components/util/MagicWords.vue